<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useAuth } from "../user/useAuth";

const AxureCloudDevToolsMenu = defineAsyncComponent(() => import("./AxureCloudDevToolsMenu.vue"));

const { user } = useAuth();

const allowDevTools = computed(() => {
  if (import.meta.env.DEV) return true;
  if (!user.value) return false;
  const email = user.value.userEmail;
  return email.endsWith("@axure.com") || email.endsWith("@axurecorp.com");
});
</script>

<template>
  <AxureCloudDevToolsMenu
    v-if="allowDevTools"
  />
</template>
